// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Quotation.css */

.quotation-container {
  font-family: Arial, sans-serif;
  margin: 0 auto;
  padding: 20px;
  max-width: 1200px;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.quotation-header {
  text-align: center;
  margin-bottom: 20px;
}

.logo {
  width: 100px;
  margin-bottom: 10px;
}

.quotation-header h1 {
  margin: 0;
  font-size: 24px;
  color: #333;
}

.quotation-header h2 {
  margin: 5px 0;
  font-size: 16px;
  color: #777;
  letter-spacing: 2px;
}

.quotation-meta {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.quotation-to {
  margin-bottom: 20px;
}

.quotation-to p,
.quotation-meta p {
  margin: 2px 0;
  flex: 1 1 200px;
}

.quotation-body p {
  line-height: 1.5;
  margin-bottom: 10px;
}

.quotation-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.quotation-table th,
.quotation-table td {
  border: 1px solid #ccc;
  padding: 10px;
  text-align: left;
}

.quotation-table th {
  background-color: #f5f5f5;
}

.terms h3 {
  font-size: 18px;
  margin-top: 30px;
  margin-bottom: 10px;
  color: #444;
}

.terms ol {
  padding-left: 20px;
  margin-bottom: 20px;
}

.terms ul {
  padding-left: 20px;
}

.quotation-footer {
  text-align: center;
  border-top: 1px solid #ddd;
  padding-top: 20px;
  font-size: 14px;
}

.quotation-footer address {
  margin-top: 10px;
  font-style: normal;
  color: #666;
}
.regarding {
  display: flex;
  justify-content: center;
  gap: 550px;
  margin-top: 70px;
}

@media (max-width: 768px) {
  .quotation-meta,
  .quotation-to {
    flex-direction: column;
    align-items: flex-start;
  }

  .quotation-table th,
  .quotation-table td {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .quotation-header h1 {
    font-size: 20px;
  }

  .quotation-header h2 {
    font-size: 14px;
  }

  .quotation-table th,
  .quotation-table td {
    padding: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Slip/Quotation.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAElB;EACE,8BAA8B;EAC9B,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE;;IAEE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAY;EACd;AACF","sourcesContent":["/* Quotation.css */\n\n.quotation-container {\n  font-family: Arial, sans-serif;\n  margin: 0 auto;\n  padding: 20px;\n  max-width: 1200px;\n  background-color: #fff;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n.quotation-header {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.logo {\n  width: 100px;\n  margin-bottom: 10px;\n}\n\n.quotation-header h1 {\n  margin: 0;\n  font-size: 24px;\n  color: #333;\n}\n\n.quotation-header h2 {\n  margin: 5px 0;\n  font-size: 16px;\n  color: #777;\n  letter-spacing: 2px;\n}\n\n.quotation-meta {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n.quotation-to {\n  margin-bottom: 20px;\n}\n\n.quotation-to p,\n.quotation-meta p {\n  margin: 2px 0;\n  flex: 1 1 200px;\n}\n\n.quotation-body p {\n  line-height: 1.5;\n  margin-bottom: 10px;\n}\n\n.quotation-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 20px;\n}\n\n.quotation-table th,\n.quotation-table td {\n  border: 1px solid #ccc;\n  padding: 10px;\n  text-align: left;\n}\n\n.quotation-table th {\n  background-color: #f5f5f5;\n}\n\n.terms h3 {\n  font-size: 18px;\n  margin-top: 30px;\n  margin-bottom: 10px;\n  color: #444;\n}\n\n.terms ol {\n  padding-left: 20px;\n  margin-bottom: 20px;\n}\n\n.terms ul {\n  padding-left: 20px;\n}\n\n.quotation-footer {\n  text-align: center;\n  border-top: 1px solid #ddd;\n  padding-top: 20px;\n  font-size: 14px;\n}\n\n.quotation-footer address {\n  margin-top: 10px;\n  font-style: normal;\n  color: #666;\n}\n.regarding {\n  display: flex;\n  justify-content: center;\n  gap: 550px;\n  margin-top: 70px;\n}\n\n@media (max-width: 768px) {\n  .quotation-meta,\n  .quotation-to {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .quotation-table th,\n  .quotation-table td {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 480px) {\n  .quotation-header h1 {\n    font-size: 20px;\n  }\n\n  .quotation-header h2 {\n    font-size: 14px;\n  }\n\n  .quotation-table th,\n  .quotation-table td {\n    padding: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
